import {useTranslations} from 'use-intl'
import {useMemo} from 'react'
import ImageComposition from '~/components/ImageComposition'
import useShopConfig from '~/hooks/useShopConfig'
import {Image, ImageFormat} from '~/gql/graphql'

type SizeImageProps = {
    className?: string
    productTypeId: string
}

const SizeImage = ({className, productTypeId}: SizeImageProps) => {
    const t = useTranslations('productDetails.sizeDialog')
    const {imageServerEndpoint} = useShopConfig()

    const image = useMemo<Image>(() => {
        const imageUrl = new URL(
            `${imageServerEndpoint}/productTypes/${productTypeId}/variants/size.webp`
        )

        return {
            src: imageUrl.toString(),
            altText: t('sizeImageAlt'),
            format: ImageFormat.Png,
        }
    }, [imageServerEndpoint, productTypeId, t])

    return <ImageComposition className={className} image={image} />
}

export default SizeImage
